export default __webpack_public_path__ + "static/media/Microcentrifuge.da35488b.svg";